<div class="w-full profile-container" *ngIf="!initialLoading">
    <div class="flex  flex-nowrap w-full p-3 gap-3 ">
        <p-toast />
        <div class="h-full relative">
            <p-card header="" class="flex h-[89vh]">
                <div class="flex space-x-2">
                    <!-- <img class="avatar-url" src="https://primefaces.org/cdn/primeng/images/demo/avatar/amyelsner.png"
                    size="large" /> -->
                    <div style="display: flex; align-items: center;">
                        <p-avatar class="mr-2" size="xlarge" shape="circle"
                            [image]="previewImage || studentDetails.photo_url"
                            *ngIf="studentDetails.photo_url != null || previewImage; else showInitials" [style]="{
                            width: '60px',
                            height: '60px',
                            borderRadius: '50%',
                            cursor: 'pointer',
                            objectFit: 'cover'
                          }" (click)="uploadInput.click()"></p-avatar>

                        <ng-template #showInitials>
                            <p-avatar class="mr-2" size="xlarge" shape="circle" label="{{ getInitials() }}" [style]="{
                              width: '60px',
                              height: '60px',
                              borderRadius: '50%',
                              fontSize: '30px',
                              cursor: 'pointer'
                            }" (click)="uploadInput.click()"></p-avatar>
                        </ng-template>

                        <input #uploadInput type="file" accept="image/*" (change)="onProfileImageUpload($event)"
                            style="display: none;" />
                    </div>



                    <div class="flex flex-col gap-3 justify-center">
                        <div class="flex flex-col gap-1">
                            <div class="text-[20px] font-bold ">
                                {{
                                getFullName()
                                }}
                            </div>
                            <div class="text-[13px]">
                                Roll No: {{studentDetails.student_roll_no}}
                            </div>
                        </div>

                    </div>
                </div>

                <div class="flex items-center gap-2 mt-4 ml-2 max-w-[300px]">
                    <div class="text-[13px] break-all">
                        {{ studentDetails.email }}
                    </div>
                    <div>
                        <i class="pi pi-clone cursor-pointer" (click)="handleCopy()"></i>
                    </div>
                </div>


                <!-- <div class="mt-5 flex gap-3"> -->

                <!-- <div class="flex flex-col items-center action-box gap-2">
                        <div class="action-icon" (click)="handleOpenEmailStudent()">
                            <i class="pi pi-envelope"></i>
                        </div>
                        <div class="text-[13px]">
                            Email
                        </div>
                    </div> -->
                <!-- <div class="flex flex-col items-center action-box gap-2">
                        <div class="action-icon" (click)="handleOpenTaskDialog()">
                            <i class="pi pi-list-check"></i>
                        </div>
                        <div class="text-[13px]">
                            Task
                        </div>
                    </div>
                    <div class="flex flex-col items-center action-box gap-2">
                        <div class="action-icon" (click)="handleOpenMeetingDialog()">
                            <i class="pi pi-calendar"></i>
                        </div>
                        <div class="text-[13px]">
                            Meeting
                        </div>
                    </div> -->
                <!-- <div class="flex flex-col items-center action-box gap-2">
                        <div class="action-icon" (click)="handleOpenCallLead()">
                            <i class="pi pi-phone"></i>
                        </div>
                        <div class="text-[13px]">
                            Call
                        </div>
                    </div> -->
                <!-- <div class="flex flex-col items-center action-box gap-2">
                    <div class="action-icon">
                        <i class="pi pi-ellipsis-h"></i>
                    </div>
                    <div class="text-[13px]">
                        More
                    </div>
                </div> -->
                <!-- </div> -->

                <p-divider class="mt-2" class="divider"></p-divider>

                <h3 class="text-[20px] -mt-1 font-semibold">Quick Actions</h3>

                <div class="flex flex-col gap-2 -mt-3">


                    <div class="mt-2">
                        <div class="mb-2 font-medium">Course</div>
                        <p-select [options]="allCourses" optionLabel="name" optionValue="course_id"
                            [(ngModel)]="selectedCourse" placeholder="Select Course" appendTo="body"
                            class="w-full rounded-sm profile-select" />
                    </div>

                    <!-- Department-->
                    <div class="mt-2">
                        <div class="mb-2 font-medium">Department</div>
                        <p-select [options]="departmentList" [(ngModel)]="selectedDepartment" appendTo="body"
                            optionLabel="name" optionValue="dept_id" placeholder="Select Department"
                            class="w-full rounded-sm profile-select" />
                    </div>

                    <!-- Academic Year -->
                    <div class="mt-2">
                        <div class="mb-2 font-medium">Academic Year</div>
                        <p-select [options]="academicYearList" optionValue="id" optionLabel="year_name"
                            [(ngModel)]="selectedAcademicYear" appendTo="body" placeholder="Select Academic Year"
                            class="w-full rounded-sm profile-select" />
                    </div>

                    <!-- Batch-->
                    <div class="mt-2">
                        <div class="mb-2 font-medium">Batch</div>
                        <p-select [options]="batchList" [(ngModel)]="selectedBatch" appendTo="body"
                            optionLabel="batch_name" optionValue="id" placeholder="Select Batch"
                            class="w-full rounded-sm profile-select" />
                    </div>

                    <!-- Fee Category -->
                    <div class="mt-2 ">
                        <div class="mb-2 font-medium">Fee Category</div>
                        <p-select [options]="feeCategoryList" [(ngModel)]="selectedFeeCategory" optionLabel="group_name"
                            optionValue="id" appendTo="body" placeholder="Select Fee Category"
                            class="w-full rounded-sm profile-select" />
                    </div>


                    <div class="mt-2">
                        <div class="mb-2 font-medium">Hostel Category</div>
                        <p-select [options]="hostelCategoryList" [(ngModel)]="selectedHostelCategory"
                            optionLabel="hostel_name" optionValue="id" appendTo="body"
                            placeholder="Select Hostel Category" class="w-full rounded-sm profile-select" />
                    </div>


                    <div class="mt-2 ">
                        <div class="mb-2 font-medium">Transport Category</div>
                        <p-select [options]="transportRouteList" [(ngModel)]="selectedTransportRoute"
                            optionLabel="route_name" optionValue="id" appendTo="body"
                            placeholder="Select Transport Category" class="w-full rounded-sm profile-select" />
                    </div>

                    <div class="mt-2 mb-16">
                        <div class="mb-2 font-medium">Scholarship Category</div>
                        <p-select [options]="scholarshipTypeList" [(ngModel)]="selectedScholarshipType"
                            optionLabel="name" optionValue="scholarship_id" appendTo="body"
                            placeholder="Select Scholarship Category" class="w-full rounded-sm profile-select" />
                    </div>


                </div>

                <div class="mt-8 flex items-center gap-2 absolute  bottom-buttons">
                    <p-button label="Back" icon="pi pi-arrow-left" (onClick)="handleBack()" severity="secondary" />
                    <p-button label="Save" class="w-full" [loading]="loading" (onClick)="handleSaveQuickActions()"
                        [disabled]="loading" />

                </div>

            </p-card>
        </div>

        <div class="flex-1">
            <app-student-profile-middle-screen [studentDetails]="studentDetails"
                [allCourses]="allCourses"
                [academicYearList]="academicYearList"
                [departmentList]="departmentList"
                [batchList]="batchList"
                [feeCategoryList]="feeCategoryList"
                [hostelCategoryList]="hostelCategoryList"
                [transportRouteList]="transportRouteList"
                [scholarshipTypeList]="scholarshipTypeList"

                [selectedTabIdx]="selectedTabIdx" (tabChanged)="selectedTabIdx = $event">
            </app-student-profile-middle-screen>
        </div>
    </div>
</div>

<div *ngIf="initialLoading" class="h-screen w-full flex items-center justify-center">
    <p-progressSpinner></p-progressSpinner>
</div>